export const routesWithoutHeaderOptions = [
  '/paseDeCoworkingPolanco',
  '/dayPassCoworkingPolanco',
  '/paseDeCoworkingCondesa',
  '/dayPassCoworkingCondesa',
  '/salaDeJuntasPolanco',
  '/meetingRoomPolanco',
];

export const routesWithoutSeekerOptions = ['/confirmar-reservacion', '/confirm-reservation'];